import type { IconProps } from './GearIcon'

export function HintIcon({ width = 20, height = 20, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M8 15.5c-.8-1-2.5-2.5-2.5-5A6.5 6.5 0 0 1 12 4a6.5 6.5 0 0 1 6.5 6.5c0 2.5-1.7 4-2.5 5" />
      <path d="M9 18h6" />
      <path d="M9.5 21h5" />
      <path d="M10.5 15.5h3" />
    </svg>
  )
}
